import { render, staticRenderFns } from "./MalattieInfettiveConfigurazioneUosdListPage.vue?vue&type=template&id=2c8136ba"
import script from "./MalattieInfettiveConfigurazioneUosdListPage.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveConfigurazioneUosdListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports